var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{staticClass:"spinning_box",attrs:{"spinning":_vm.spinning}},[_c('div',{staticClass:"dataScreen_content_2box_top"},[_c('video',{staticClass:"dataScreen_content_2box_top_img",attrs:{"autoplay":"","loop":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.record.mp4,"type":"video/mp4"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }